import type { ComponentProps } from 'react';
import React from 'react';

import Separator from 'common/components/Separator';

const AddToCartSeparator = (props: ComponentProps<typeof Separator>) => (
  <Separator mt="sp_16" mb={['sp_16', 'sp_20', null, 'sp_24']} {...props} />
);

export default AddToCartSeparator;
